module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"MC+A","short_name":"MC+A","start_url":"/","background_color":"#43344F","theme_color":"#43344F","display":"minimal-ui","icon":"src/images/logomark-512.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"b0e19f25d8f36a3e16365ac156397b3b"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
